import * as React from 'react';
const SvgMap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m7.513 2.999.042-.001h.04l.06.007.015.003q.114.019.223.082l.046.03 4.507 3.169 4.503-3.166a.667.667 0 0 1 1.044.452l.006.093v9.45a.67.67 0 0 1-.212.487l-.071.059-4.889 3.436a.66.66 0 0 1-.735.02L7.555 13.93l-4.506 3.168a.667.667 0 0 1-1.044-.453L2 16.552v-9.45c0-.186.078-.362.212-.488l.071-.058L7.171 3.12a.7.7 0 0 1 .177-.09l.109-.025zm9.153 1.953L13.11 7.45v7.82l3.555-2.499zm-9.779-.003L3.332 7.448v7.82l3.555-2.499zm1.336 0v7.82l3.555 2.5V7.447z"
    />
  </svg>
);
export default SvgMap;
